export default __webpack_public_path__ + "static/media/step2.3f7ec459.webp";